import { render, staticRenderFns } from "./AllTickets.vue?vue&type=template&id=06b62f36&scoped=true&"
import script from "./AllTickets.vue?vue&type=script&lang=js&"
export * from "./AllTickets.vue?vue&type=script&lang=js&"
import style0 from "./AllTickets.vue?vue&type=style&index=0&id=06b62f36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b62f36",
  null
  
)

export default component.exports